module.exports = new __parcel__URL__("jsm-change-management.c2f0cbc4.svg").toString();